import React from 'react';
import { twMerge } from 'tailwind-merge';

export function IconPf25Admins({ onClick, className, color = '#000' }) {
  return (
    <svg
      onClick={onClick}
      className={twMerge(' w-6 h-6 group', className)}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.81484 10.87C9.71484 10.86 9.59484 10.86 9.48484 10.87C7.10484 10.79 5.21484 8.84 5.21484 6.44C5.21484 3.99 7.19484 2 9.65484 2C12.1048 2 14.0948 3.99 14.0948 6.44C14.0848 8.84 12.1948 10.79 9.81484 10.87Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.815 20.43C2.395 18.82 2.395 16.18 4.815 14.56C6.23872 13.616 8.12811 13.159 10 13.1889"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99957 13.1889C11.0206 13.1726 12.0469 13.3011 13 13.5746"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 19.225L14.923 18.843M14.923 16.547L14 16.164M16.547 14.923L16.164 14M16.547 20.467L16.164 21.391M18.843 14.923L19.226 14M19.225 21.391L18.843 20.467M20.467 16.547L21.391 16.164M20.467 18.843L21.391 19.226M20.695 17.695C20.695 19.3519 19.3519 20.695 17.695 20.695C16.0381 20.695 14.695 19.3519 14.695 17.695C14.695 16.0381 16.0381 14.695 17.695 14.695C19.3519 14.695 20.695 16.0381 20.695 17.695Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
